import React from 'react';

import {
    IconCalendarPaid, IconClockTable,
    IconMarkerTable, IconScheduleTable,
    PeopleTalking, PersonOutlinedChip,
    StarCalendarTitle
} from "../../../../../components/buttons/IconButtons";
import CustomCard from "../../../../../components/CustomCard";
import CustomUserChip from "../../../../../components/CustomUserChip";
import {EMPTY_VALUES, getDateFormat, getTimeFormat} from "../../../../../Apis/functions";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import LocationCard from "../../../Visitor/External/LocationCard";

/**
 *
 * @Author: Karen Yunuen pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const SuccessfullyEventDetails = ({
    latLng,
    t,
    setLatitude,
    setLongitude,
    getPublicEventDetail,
    direction,
    chipStatus,
    monthDay
}) => {
    return (
        <>
            <CustomCard classes={"w-100"} classCard={'card-border-8px border-0 p-10px box-shadow-shades-150-4-12px'} classContent={'p-0 m-0'}>
                {/*HEADER*/}
                <div className={'d-flex align-items-center mb-2 justify-content-between'}>
                    <div className={"d-flex align-items-center"}>
                        <div className="icons-invitation-start">
                            <StarCalendarTitle className="w-100 h-100"/>
                        </div>

                        <p className={'fs-16-to-14 ibl-font-w-600 font-color-general-950 text-left pl-1'}>
                            {t("event_details")}
                        </p>
                    </div>

                    <CustomUserChip
                        className={`m-0 p-0 ${chipStatus?.className ? chipStatus.className : ''}`}
                        name={t(chipStatus?.name) || EMPTY_VALUES.DEFAULT}
                        showAvatar={false}
                        variant='large'
                    />
                </div>
                <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                    <div className="">
                        <PeopleTalking className="w-100 h-100" />
                    </div>

                    <div className={'row'}>
                        <div className="my-2 d-flex flex-column">
                            <div className={'d-flex justify-content-between align-items-stretch w-100'}>
                                <div className={'d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 h-100'}>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <IconCalendarPaid />
                                        <p className={"font-color-general-950 fs-14px px-2"}>
                                            {getPublicEventDetail?.name}
                                        </p>
                                    </div>
                                </div>
                                {/*CALENDAR*/}
                                <div className="custom-date-box h-100">
                                    <div className="custom-date-box-top">{monthDay?.month || EMPTY_VALUES.DEFAULT}</div>
                                    <div className="custom-date-box-bottom">{monthDay?.day || EMPTY_VALUES.DEFAULT}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'border-bottom-shades-300'} />

                    <div className={'row my-2'}>
                        <div className={'col-12 mb-3'}>
                            <CustomGenericTittleIconDataChip title={t('hosted_by')} />
                            <div className='mt-2 d-flex align-items-center'>
                                <PersonOutlinedChip />
                                <p className={"font-color-general-950 fs-14px ml-2"}>
                                    {getPublicEventDetail?.host?.fullName}
                                </p>
                            </div>
                        </div>

                        <div className={'col-12 col-md-6'}>
                            <CustomGenericTittleIconDataChip title={t('date_and_time')} />
                            <div className={"mt-2"}>
                                <div className={" d-flex align-items-center"}>
                                    <IconScheduleTable className="icon-color-general-950" />
                                    <p className={"font-color-general-950 fs-14px ml-2"}>
                                        {getDateFormat(getPublicEventDetail?.startDate, false)}
                                        &nbsp;{t("to").toLowerCase()}&nbsp;
                                        {getDateFormat(getPublicEventDetail?.endDate, false)}
                                    </p>
                                </div>
                                <div className={"d-flex align-items-center"}>
                                    <IconClockTable className="icon-color-general-950" />
                                    <p className={"font-color-general-950 fs-14px ml-2"}>
                                        {getTimeFormat(getPublicEventDetail?.startDate)}
                                        &nbsp;{t("to").toLowerCase()}&nbsp;
                                        {getTimeFormat(getPublicEventDetail?.endDate)}
                                    </p>
                                </div>
                            </div>
                        </div>



                        <div className={'col-12 col-md-6 mt-3 mt-md-0'}>
                            <CustomGenericTittleIconDataChip title={t('access_zone')} />
                            <div className={"mt-2"}>
                                <div className={"d-flex"}>
                                    <IconMarkerTable className={"mr-8px mb-1"} />
                                    <p className={"font-color-general-950 fs-14px ml-2"}>{getPublicEventDetail?.reservation?.zone?.name}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomCard>
            </CustomCard>

            <CustomCard classes="w-100 h-100 mb-2" classCard="card-border-8px border-0 p-10px box-shadow-shades-150-4-12px"  classContent="p-0">
                {latLng?.length >= 2 &&
                <LocationCard
                    t={t}
                    latlng={latLng}
                    setLatitude={setLatitude}
                    setLongitude={setLongitude}
                    mainZone={getPublicEventDetail?.reservation?.zone?.name || ''}
                    subZone={''}
                    location={direction || EMPTY_VALUES.DEFAULT}
                    classNameMap="h-125px w-100"
                    disabled={true}
                    title={"location"}
                />
                }
            </CustomCard>
        </>
    )

}

export default SuccessfullyEventDetails
